
<div class="container-fluid position-relative h-100 align-items-center overflow-hidden"
    [ngClass]="[bgPosition, bgColor]"
    [ngStyle]="{'background-image': useImage ? 'url(' + urlImage + ')' : '', 'min-height': minHeight}">

    <ng-content></ng-content>
</div>